export default __webpack_public_path__ + "static/media/mobileBanner.95ea1d35.svg";